//  UUID v4 generator in JavaScript (RFC4122 compliant)
//  https://gist.github.com/jcxplorer/823878

export default class UUID {
  static generateUUID(): string {
    let uuid = '';
    for (let i = 0; i < 32; i += 1) {
      // eslint-disable-next-line no-bitwise
      const random = Math.random() * 16 | 0;
      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-';
      }
      // eslint-disable-next-line no-nested-ternary
      uuid += (i === 12
        ? 4
        : (i === 16
          ? (random & 3 | 8) // eslint-disable-line no-bitwise, no-mixed-operators
          : random)).toString(16);
    }
    return uuid;
  }

  static generateUniqueID(): string {
    return this.generateUUID().replace('-', '');
  }
}
